export const movies = [
  {
    id: "deep-sea-echo",
    title: "深海回声",
    en: "Echoes of the Deep",
    type: "movie",
    genres: ["剧情", "悬疑"],
    region: "中国大陆",
    year: 2026,
    rating: 8.7,
    director: "陈屿",
    cast: ["张承宇", "周芷宁", "李牧", "何晴"],
    length: "128分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20lone%20diver%20silhouette%20suspended%20in%20deep%20dark%20ocean%20water%20with%20pale%20shafts%20of%20light%20piercing%20the%20surface%20and%20drifting%20particles%20dramatic%20moody%20lighting%20muted%20deep%20navy%20and%20warm%20amber%20palette%20abstract%20atmospheric%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-deepsea&orientation=portrait",
    intro: "一场深海事故，把两代人的沉默一起打捞上岸。",
    synopsis:
      "海洋工程师林潮受命调查一起发生在千米深海的潜水器失联事故，唯一的线索是母亲二十年前留下的研究笔记。\n\n随着下潜深度不断增加，他发现所谓的设备故障背后，是一场被刻意掩埋的科研事故，而当年签下保密协议的人里，有他朝夕相处的父亲。海面上的风暴与海底的寂静同时逼近，林潮必须决定，是让回声继续沉睡，还是把它带回人间。",
    tags: ["深海", "家庭秘密", "记忆"],
    reviews: [
      {
        author: "沈青",
        role: "资深影评人",
        score: 8.9,
        title: "沉默比深海更冷",
        excerpt: "导演把大量镜头留给水压与呼吸声，情绪不靠台词推进，而是靠光线的变化一点点挤出来。",
      },
      {
        author: "程野",
        role: "电影研究员",
        score: 8.5,
        title: "一次克制的类型片尝试",
        excerpt: "结尾没有给出廉价的谅解，父子之间的空白被留在镜头里，这份克制值得尊重。",
      },
    ],
  },
  {
    id: "long-night",
    title: "长夜将尽",
    en: "The Long Night",
    type: "movie",
    genres: ["犯罪", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    director: "韩牧",
    cast: ["段奕辰", "秦岚青", "徐立", "邹浩然"],
    length: "136分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20rain%20soaked%20empty%20city%20street%20at%20midnight%20with%20a%20lone%20figure%20walking%20under%20a%20flickering%20street%20lamp%20reflections%20on%20wet%20asphalt%20dramatic%20chiaroscuro%20lighting%20muted%20deep%20navy%20and%20warm%20amber%20palette%20gritty%20atmospheric%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-longnight&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20rain%20soaked%20city%20street%20at%20night%20with%20glowing%20street%20lamps%20wet%20asphalt%20reflections%20and%20a%20distant%20lone%20figure%20deep%20navy%20blue%20tonality%20with%20warm%20amber%20highlights%20moody%20noir%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-longnight&orientation=landscape",
    intro: "刑警老段退休前的最后一个案子，牵出整条街道的秘密。",
    synopsis:
      "在旧城区改造倒计时的最后三十天里，一具被埋进水泥地下的尸体重见天日。距离退休只剩两周的老刑警段明远接下这个案子，却发现所有证词都指向同一个已经被拆除的门牌号。\n\n他沿着即将消失的街巷逐个敲门，遇见了守着修鞋摊的老人、准备搬走的年轻夫妻、以及二十年前那场火灾里唯一活下来的女孩。每个人都说了真话，但没有一个人说完整。长夜将尽时，段明远才明白，自己也是这条街的共犯之一。",
    tags: ["旧城", "悬案", "现实主义"],
    reviews: [
      {
        author: "林未",
        role: "影评人",
        score: 9.1,
        title: "把罪案片拍成了城市挽歌",
        excerpt: "拆迁的灰尘就是这部电影的底片，破案只是外壳，真正被追问的是谁有权决定一条街的消失。",
      },
      {
        author: "白榆",
        role: "专栏作者",
        score: 8.8,
        title: "老段最后那支烟",
        excerpt: "全片最好的一场戏没有一句台词，只有打火机三次打不着的声响，把一个人的一生说完了。",
      },
    ],
  },
  {
    id: "seventh-spring",
    title: "第七个春天",
    en: "The Seventh Spring",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2025,
    rating: 8.3,
    director: "岩井俊介",
    cast: ["藤原樱", "高桥凉", "小林千夏"],
    length: "112分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20cherry%20blossom%20petals%20drifting%20through%20a%20sunlit%20empty%20train%20carriage%20window%20in%20early%20spring%20soft%20pastel%20mist%20warm%20gentle%20light%20muted%20deep%20navy%20and%20pale%20amber%20palette%20romantic%20nostalgic%20atmosphere%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-spring&orientation=portrait",
    intro: "她记得每一个春天，却记不住那个每年都来的人。",
    synopsis:
      "花店店主千夏在七年前的一场事故后失去了部分记忆，只保留了关于季节的模糊印象。每年樱花开放时，都会有一个陌生男人来买同一束白色小花，从不留名字。\n\n第七个春天，男人终于带来一本写满日期的旧笔记本。千夏翻开它，看到的是自己从未记得的、被人小心保存下来的七年。影片用四个季节的结构，讲述记忆如何被爱一点点修补，也讲述有些遗憾注定无法复原。",
    tags: ["记忆", "四季", "温柔"],
    reviews: [
      {
        author: "叶知秋",
        role: "影评人",
        score: 8.4,
        title: "把失忆拍得不俗气",
        excerpt: "它没有把遗忘当作戏剧工具，而是当作一种生活状态，淡淡地铺在每一顿饭和每一次告别里。",
      },
      {
        author: "苏木",
        role: "自由撰稿人",
        score: 8.2,
        title: "第七年才等到的答案",
        excerpt: "最后那束白花放在空椅子上的镜头，比任何一句告白都更接近爱情的本意。",
      },
    ],
  },
  {
    id: "wasteland-courier",
    title: "荒原信使",
    en: "Wasteland Courier",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2026,
    rating: 8.1,
    director: "伊桑·科尔",
    cast: ["玛拉·维恩", "德文·霍克", "奥斯卡·里德"],
    length: "141分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20lone%20traveler%20in%20a%20long%20coat%20crossing%20an%20enormous%20barren%20desert%20ridge%20toward%20a%20distant%20glowing%20structure%20dust%20in%20the%20air%20cinematic%20wide%20sky%20muted%20deep%20navy%20and%20burnt%20amber%20palette%20epic%20atmospheric%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-wasteland&orientation=portrait",
    intro: "文明断线之后，最后一封信要走三千公里。",
    synopsis:
      "通讯网络崩溃的第十年，信使凯拉靠着一台老旧的导航仪穿越无人区，为散落的定居点传递手写书信。这次她接到的委托格外特殊：把一个十岁女孩送到大陆另一端，而女孩本人就是那封「信」。\n\n沿途的沙暴、废弃的城市和不肯放手的人，让这段旅程逐渐偏离路线。凯拉开始怀疑委托人的身份，也开始意识到，自己护送的或许不是希望，而是一场新的争夺。",
    tags: ["末世", "公路", "书信"],
    reviews: [
      {
        author: "周衍",
        role: "科幻评论者",
        score: 8.3,
        title: "末日里最稀缺的是地址",
        excerpt: "影片把宏大的世界观压缩成两个人和一条路线，反而让废墟有了体温。",
      },
      {
        author: "Nora",
        role: "影视编辑",
        score: 7.9,
        title: "视听撑起了剧本的短板",
        excerpt: "沙暴长镜头值回票价，中段的转折略显仓促，但结尾的选择足够动人。",
      },
    ],
  },
  {
    id: "changan-wind",
    title: "风起长安",
    en: "Wind Over Chang'an",
    type: "movie",
    genres: ["古装", "动作"],
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    director: "顾长风",
    cast: ["陈书言", "苏晚", "齐越", "罗敬"],
    length: "148分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20sword%20bearing%20figure%20in%20flowing%20ancient%20chinese%20robes%20standing%20on%20a%20palace%20roof%20at%20dusk%20with%20banners%20and%20distant%20lanterns%20dramatic%20wind%20swept%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20painterly%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-changan&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20ancient%20chinese%20capital%20city%20at%20dusk%20with%20layered%20rooftops%20glowing%20lanterns%20and%20mist%20over%20distant%20mountains%20deep%20navy%20blue%20sky%20with%20warm%20amber%20lantern%20light%20painterly%20epic%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-changan&orientation=landscape",
    intro: "一封没有署名的密诏，让整座长安城的风向都变了。",
    synopsis:
      "天宝年间，负责修缮宫城的小吏沈砚意外在一根梁柱里发现了先帝留下的密诏，内容牵涉到当朝最不能碰的一桩旧案。他本想烧掉它，却发现自己的名字早已写在其中。\n\n从东西两市到曲江池畔，沈砚被三方势力同时追索。他唯一能信任的，是一个在教坊司里弹琵琶的盲女。风起时，长安城的每一片瓦都在响，而真相往往比刀更快。",
    tags: ["长安", "权谋", "动作设计"],
    reviews: [
      {
        author: "顾南",
        role: "古装剧研究者",
        score: 8.7,
        title: "打戏终于回到了地面",
        excerpt: "没有无重力飞檐，每一次刀锋相撞都有重量，这种笨拙的实感反而更靠近武侠。",
      },
      {
        author: "薛迟",
        role: "影评人",
        score: 8.3,
        title: "长安是个会说谎的地方",
        excerpt: "美术极尽繁华，人物却一个个走向失语，这种反差点出了整部片子的野心。",
      },
    ],
  },
  {
    id: "glasshouse",
    title: "玻璃温室",
    en: "The Glasshouse",
    type: "movie",
    genres: ["家庭", "剧情"],
    region: "法国",
    year: 2024,
    rating: 7.9,
    director: "克莱尔·杜邦",
    cast: ["伊莎贝尔·罗", "吕克·马雷", "艾玛·菲永"],
    length: "104分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20weathered%20glass%20greenhouse%20filled%20with%20overgrown%20plants%20and%20filtered%20afternoon%20sunlight%20a%20small%20child%20silhouette%20among%20the%20leaves%20quiet%20melancholic%20mood%20muted%20deep%20navy%20and%20soft%20amber%20palette%20film%20grain%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-glasshouse&orientation=portrait",
    intro: "一座不肯拆的温室，困住了三代人的夏天。",
    synopsis:
      "母亲去世后，三兄妹回到南方乡下的老宅，准备卖掉那座早已荒废的玻璃温室。整理遗物时，他们发现母亲每年夏天都会在温室里种下同一种不结果的花。\n\n随着温室被一点点清理，关于父亲离开的真正原因、关于那场没人提起的车祸，被重新摆到桌上。争吵、沉默、和解都发生在同一片玻璃屋顶下，阳光穿过裂纹，把每个人照得无处躲藏。",
    tags: ["家庭", "遗产", "夏天"],
    reviews: [
      {
        author: "唐寻",
        role: "影评人",
        score: 8.0,
        title: "不结果的花也是一种答案",
        excerpt: "影片拒绝给出和解的仪式感，只让三个人安静地吃完一顿饭，这种留白非常法式。",
      },
      {
        author: "季川",
        role: "专栏作者",
        score: 7.7,
        title: "光影比台词更会说谎",
        excerpt: "温室里的每一次曝光过度，都对应着人物的一次回避，摄影是有想法的。",
      },
    ],
  },
  {
    id: "zero-plan",
    title: "归零计划",
    en: "Project Zero",
    type: "movie",
    genres: ["科幻", "悬疑"],
    region: "韩国",
    year: 2026,
    rating: 8.4,
    director: "朴正勋",
    cast: ["李在勋", "金瑞妍", "崔武成"],
    length: "122分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20dark%20server%20room%20corridor%20with%20a%20single%20human%20silhouette%20facing%20a%20giant%20glowing%20circular%20interface%20cold%20reflections%20cinematic%20sci%20fi%20atmosphere%20muted%20deep%20navy%20and%20electric%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-zeroplan&orientation=portrait",
    intro: "记忆可以备份，但代价是有人必须被删除。",
    synopsis:
      "记忆云服务公司「归零」推出一项新功能：把人的短期记忆上传，随时回看。工程师郑河在内部测试时发现，系统里存在一批从未被登记的记忆片段，全部来自同一个人。\n\n追查过程中，他见到了片段的主人——一个据官方记录已经死亡七年的女人。公司高层开始封锁权限，郑河只能用自己的备份记忆作为交换条件，去换一个真相。而当真相浮出水面，他发现自己也是那批数据的一部分。",
    tags: ["记忆上传", "科技伦理", "反转"],
    reviews: [
      {
        author: "韩知远",
        role: "类型片观察者",
        score: 8.6,
        title: "把老命题拍出了新焦虑",
        excerpt: "真正的恐怖不是被删除，而是你无法证明自己曾经存在过。",
      },
      {
        author: "梁一",
        role: "电影编辑",
        score: 8.2,
        title: "冷色调里的温度",
        excerpt: "结尾那场雨戏拍得很克制，男主没有嘶吼，只是反复确认自己的名字。",
      },
    ],
  },
  {
    id: "white-bird-bell",
    title: "白鸟与钟",
    en: "White Bird, Old Bell",
    type: "movie",
    genres: ["动画", "奇幻"],
    region: "日本",
    year: 2025,
    rating: 8.8,
    director: "宫田澄",
    cast: ["小林遥", "佐藤原", "松本千惠"],
    length: "98分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20anime%20movie%20poster%20artwork%20of%20a%20white%20bird%20flying%20over%20a%20snow%20covered%20hill%20town%20with%20an%20old%20bronze%20bell%20tower%20warm%20sunset%20light%20painted%20illustration%20style%20soft%20textures%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-whitebird&orientation=portrait",
    intro: "钟声响起的时候，死去的人会变成一只鸟回来。",
    synopsis:
      "山间小镇的老钟楼已经停摆十九年。转学生小凪在放学后听见了钟声，追着声音找到了一个自称「守钟人」的男孩。男孩告诉她，每敲一次钟，就能让一个还没说完再见的人短暂回来。\n\n小凪想见的是三年前离开的母亲，但守钟人警告她，钟声只能用一次，而用了的人会失去关于那个人的全部记忆。影片用手绘质感的画面，讲了一个关于告别练习的温柔故事。",
    tags: ["手绘", "告别", "奇幻"],
    reviews: [
      {
        author: "林馥",
        role: "动画评论人",
        score: 9.0,
        title: "今年最安静的一场雪",
        excerpt: "没有反派，没有拯救世界，只有一个人学着把再见说完整。",
      },
      {
        author: "陈默",
        role: "影评人",
        score: 8.7,
        title: "钟声是留给活人的",
        excerpt: "结尾空镜里的钟楼停了很久，观众才意识到，回不来的从来不是逝者。",
      },
    ],
  },
  {
    id: "last-metro",
    title: "末班地铁",
    en: "The Last Metro",
    type: "movie",
    genres: ["惊悚", "悬疑"],
    region: "中国香港",
    year: 2025,
    rating: 7.6,
    director: "麦子豪",
    cast: ["郑乐言", "何嘉欣", "黄锦"],
    length: "106分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20an%20empty%20late%20night%20subway%20carriage%20with%20flickering%20fluorescent%20lights%20and%20one%20distant%20passenger%20silhouetted%20against%20a%20rainy%20platform%20view%20tense%20mysterious%20atmosphere%20muted%20deep%20navy%20and%20dull%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-lastmetro&orientation=portrait",
    intro: "零点零七分，这趟车不该出现在线路图上。",
    synopsis:
      "代驾司机阿森赶最后一班地铁回家，却在车厢里发现所有乘客都戴着同一款耳塞，且没有一个人在下一站下车。列车广播报出的站名，是他童年住过、早已被拆除的旧区。\n\n当他想在下一站逃离时，车门打开，站台上站着二十年前的自己。影片用密闭空间和高密度音效，把一个关于悔恨的夜晚拉长到极限。",
    tags: ["密闭空间", "夜班", "城市传说"],
    reviews: [
      {
        author: "阿Ken",
        role: "影评人",
        score: 7.8,
        title: "港式惊悚的一次回魂",
        excerpt: "音效设计极其凶狠，几场静默戏比 jump scare 更让人坐立不安。",
      },
      {
        author: "温晴",
        role: "影视编辑",
        score: 7.4,
        title: "设定大于逻辑",
        excerpt: "前三分之二非常抓人，结尾的解释稍显潦草，但作为类型片仍然值得一看。",
      },
    ],
  },
  {
    id: "beyond-dune",
    title: "沙丘之外",
    en: "Beyond the Dunes",
    type: "movie",
    genres: ["纪录", "冒险"],
    region: "英国",
    year: 2024,
    rating: 8.2,
    director: "艾略特·格雷",
    cast: ["詹姆斯·凯", "阿米娜·哈桑"],
    length: "96分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20documentary%20movie%20poster%20artwork%20of%20vast%20sand%20dunes%20with%20long%20shadows%20at%20golden%20hour%20a%20tiny%20caravan%20of%20figures%20crossing%20the%20ridge%20sweeping%20wind%20patterns%20quiet%20epic%20scale%20muted%20deep%20navy%20and%20warm%20sand%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-dune&orientation=portrait",
    intro: "三年，两千公里，一群人跟着风走。",
    synopsis:
      "纪录片团队跟随一支古老的商队，穿越世界上最大的流动沙漠。镜头记录的不只是地貌变化，还有三代人对「离开」的不同理解：老人坚持走完祖先的路线，中年人在绿洲与城市之间摇摆，少年则第一次见到真正的星空。\n\n没有旁白说教，只有风声、驼铃和篝火边的闲谈。影片最后十分钟的沙暴长镜头，被称为近年纪录片中最壮丽的一段影像。",
    tags: ["纪录片", "沙漠", "人文"],
    reviews: [
      {
        author: "顾行",
        role: "纪录片导演",
        score: 8.4,
        title: "把镜头交还给风",
        excerpt: "最难得的是它不急着解释意义，让观众自己在沙子里站一会儿。",
      },
      {
        author: "陆遥",
        role: "影评人",
        score: 8.0,
        title: "壮丽之下是具体的人",
        excerpt: "篝火边那段关于名字的讨论，是全片最轻也最重的部分。",
      },
    ],
  },
  {
    id: "summer-end",
    title: "我们在夏天结尾",
    en: "At Summer's End",
    type: "movie",
    genres: ["爱情", "青春"],
    region: "中国台湾",
    year: 2026,
    rating: 8.0,
    director: "林知夏",
    cast: ["许安安", "陈亦州", "廖子晴"],
    length: "110分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20two%20teenagers%20sitting%20on%20a%20seaside%20concrete%20breakwater%20at%20the%20end%20of%20summer%20with%20soft%20twilight%20sky%20and%20distant%20ferris%20wheel%20nostalgic%20warm%20glow%20muted%20deep%20navy%20and%20peach%20amber%20palette%20film%20photography%20look%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-summerend&orientation=portrait",
    intro: "那个夏天没有结束，只是我们不再回去了。",
    synopsis:
      "高三暑假，阿远和小静在小镇的海堤上约定，等放榜那天一起去台北。台风过境前的最后一周，两个人各自藏着没说出口的消息：一个收到了保送通知，一个家里准备搬去南部。\n\n他们照常去冰店、照常骑车绕海边，把所有告别都伪装成日常。影片用大量固定机位和自然光，拍出了青春里最真实的那种迟钝。",
    tags: ["青春", "夏日", "离别"],
    reviews: [
      {
        author: "苏念",
        role: "影评人",
        score: 8.1,
        title: "不煽情的青春片",
        excerpt: "没有暴雨中的告白，只有冰店里融化得太快的刨冰，这才是我们经历的十八岁。",
      },
      {
        author: "陈映",
        role: "专栏作者",
        score: 7.9,
        title: "海堤上的两双拖鞋",
        excerpt: "导演很懂留白，最后那个空镜头比任何台词都更像一句再见。",
      },
    ],
  },
  {
    id: "under-iron",
    title: "铁幕之下",
    en: "Under the Iron Curtain",
    type: "movie",
    genres: ["历史", "战争"],
    region: "德国",
    year: 2025,
    rating: 8.6,
    director: "汉斯·魏斯",
    cast: ["卡尔·布伦", "艾娃·雷曼", "尤里·施密特"],
    length: "154分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20artwork%20of%20a%20divided%20european%20city%20street%20in%20the%201960s%20with%20cold%20fog%20a%20lone%20man%20in%20a%20hat%20walking%20past%20concrete%20barriers%20muted%20desaturated%20deep%20navy%20and%20amber%20accents%20historical%20dramatic%20tone%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-iron&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20divided%20european%20city%20street%20in%20cold%20morning%20fog%20with%20concrete%20barriers%20and%20old%20apartment%20facades%20desaturated%20deep%20navy%20tones%20with%20warm%20amber%20window%20lights%20historical%20drama%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-iron&orientation=landscape",
    intro: "一堵墙升起之前，两个家庭已经先被分开了。",
    synopsis:
      "1961年的柏林，铁路工人汉斯与犹太裔妻子莉泽住在同一栋公寓的两侧。一夜之间，铁丝网把街区切成两半，也把他们的日常切成两半。\n\n影片用四年时间跨度，讲述这对夫妻如何在墙的阴影下维持一个家庭：通过窗户传递的字条、被反复修改的通行证、以及一个最终不得不做出的选择。没有英雄，只有普通人试图守住一点点正常生活。",
    tags: ["冷战", "柏林", "家庭"],
    reviews: [
      {
        author: "周慕",
        role: "历史题材研究者",
        score: 8.8,
        title: "墙是具体的，恐惧也是",
        excerpt: "它没有把历史当成背景板，而是让历史直接长在厨房、楼道和床铺之间。",
      },
      {
        author: "Eva",
        role: "影评人",
        score: 8.4,
        title: "克制到最后一分钟",
        excerpt: "结尾没有拥抱，只有隔着铁网递过去的一支烟，这种分寸感极其难得。",
      },
    ],
  },
];